import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TokenManagerProvider } from './contexts/TokenManagerContext';
import ApolloProviderWrapper from './providers/ApolloProvider';
import AppRouter from './containers/AppRouter';
import SyncArtistSubdomain from './components/SyncArtistSubdomain';
import { WalkthroughProvider } from './stores/WalkthroughComplete';

const App: React.FC = () => {
  return (
    <TokenManagerProvider>
      <WalkthroughProvider>
        <ApolloProviderWrapper>
          <Router>
            <SyncArtistSubdomain />
            <AppRouter />
          </Router>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        </ApolloProviderWrapper>
      </WalkthroughProvider>
    </TokenManagerProvider>
  );
};

export default App;